import { Task } from '../api/types';

export interface PlanDateRange {
  /** ISO (AAAA-MM-JJ) de la date de début la plus ancienne parmi les tâches datées. */
  start: string;
  /** ISO (AAAA-MM-JJ) de la date de fin la plus tardive parmi les tâches datées. */
  end: string;
}

/**
 * Plage par défaut d'un planning : de la première date de début à la
 * dernière date de fin, tous jalons/tâches datés confondus. Utilisée à la
 * fois pour pré-remplir l'affichage de la plage d'export PDF (voir
 * PdfExportSettingsModal) et comme repli au moment de la génération réelle
 * du PDF quand aucune plage explicite n'a été choisie (voir pdfExport.ts).
 * Retourne null si aucune tâche n'a de dates.
 */
export function planDateRange(tasks: Task[]): PlanDateRange | null {
  let start: string | null = null;
  let end: string | null = null;
  for (const task of tasks) {
    if (!task.startDate || !task.endDate) continue;
    const s = task.startDate.slice(0, 10);
    const e = task.endDate.slice(0, 10);
    if (!start || s < start) start = s;
    if (!end || e > end) end = e;
  }
  return start && end ? { start, end } : null;
}
